






































import Vue from "vue";
import { required } from "vuelidate/lib/validators";

import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import { UserUpdateForm } from "../forms/UserUpdateForm";
import { Role } from "../../role/models/Role";

export default Vue.extend({
  mixins: [permission, dialog],
  validations: {
    userUpdateform: {
      newRole: {
        required
      }
    }
  },
  data() {
    const userUpdateform: UserUpdateForm = { newRole: 0 };
    const roles: Role[] = [];
    return { roles, userUpdateform };
  },
  async created() {
    await Promise.all([
      this.getRoles(),
      this.getUserById(+this.$route.params.id)
    ]);
  },
  computed: {
    roleError() {
      return (this as any).$v.userUpdateform.newRole.$error
        ? "Role is required or invalid."
        : "";
    },
    hasUserViewPermission() {
      return (this as any).hasPermission(PermissionName.USER_VIEW);
    }
  },
  methods: {
    async getRoles() {
      try {
        const { data } = await (this as any).$dep.roleUseCase.getRoles({
          perPage: 9999
        });
        this.roles = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getUserById(id: number) {
      try {
        const { data } = await (this as any).$dep.userUseCase.getUser(id);
        this.userUpdateform = { user: data, newRole: data.role.id };
      } catch (error) {
        console.log(error.response);
      }
    },
    async updateUser() {
      try {
        await (this as any).$dep.userUseCase.updateUser(this.userUpdateform);
        if (await (this as any).alertSuccess("Success", "แก้ไข User สำเร็จ")) {
          this.goToUserViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถแก้ไข User ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    goToUserViewPage() {
      this.$router.push({ name: "UserViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update user",
        "คุณต้องการแก้ไข User หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateUser();
      }
    },
    async clear() {
      this.$v.$reset();
      this.userUpdateform = {
        ...this.userUpdateform,
        newRole: this.userUpdateform.user!.role.id
      };
    }
  }
});
